// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__eh2Dz","main":"layout_main__zxVHc","grid":"layout_grid__gJAKC"};